'use strict';

var React = require('react');
var component = require('../../Tooltip/component.js');
var cell_styles = require('./cell.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Cell = React__default.default.forwardRef(({ disableTooltip = false, tooltipDisabled = false, noEllipsis, noVerticalPadding, children, important, ...props }, ref) => {
    const cellContentRef = React.useRef(null);
    const [isTootlipOpen, setIsTooltipOpen] = React.useState(false);
    const _tooltipDisabled = tooltipDisabled || disableTooltip;
    const shouldShowTooltip = !noEllipsis && !_tooltipDisabled;
    const onMouseEnter = (e) => {
        if (shouldShowTooltip && e.currentTarget.offsetWidth < e.currentTarget.scrollWidth) {
            setIsTooltipOpen(true);
        }
    };
    const onMouseLeave = () => {
        setIsTooltipOpen(false);
    };
    return (React__default.default.createElement(cell_styles.CellStyled, { "$noVerticalPadding": noVerticalPadding, "$important": important, ref: ref, ...props },
        React__default.default.createElement(cell_styles.CellContentStyled, { ref: cellContentRef, onMouseEnter: shouldShowTooltip ? onMouseEnter : undefined, onMouseLeave: onMouseLeave, "$noEllipsis": noEllipsis }, children),
        shouldShowTooltip && isTootlipOpen ? (React__default.default.createElement(component.Tooltip, { placement: "bottom-left", target: cellContentRef.current, isOpened: isTootlipOpen, onOpenedChange: setIsTooltipOpen }, children)) : null));
});

exports.Cell = Cell;
//# sourceMappingURL=cell.js.map
